import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import {Dialog, DialogTitle, TextField} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import React, {useState} from "react";
import {Wheel} from "@uiw/react-color";
import {MAIN_BACKGROUND_COLOR} from "../CONSTANTS";
import ntc from "ntcjs";
import Button from "@mui/material/Button";
import {Option} from "../core/Option";
import {useSnackbar} from "notistack";

interface IProps{

    open: boolean;
    handleClose: () => void;
    handleUpdate: (option: Option) => void;
    handleRemove: () => void;

    initialState: {
        option: Option
    }

}

export default function EditOptionPopup(props: IProps)
{
    const { open, handleClose, handleUpdate, handleRemove, initialState } = props;

    const { enqueueSnackbar } = useSnackbar();

    const [name, setName] = useState<string>(initialState.option.name);
    const [color, setColor] = useState<string>(initialState.option.color);

    const [showConfirmDelete, setShowConfirmDelete] = useState(false);

    const handleModify = () => {
        if(name.length === 0)
        {
            enqueueSnackbar("Please enter a name first", { variant: "error" });
            return;
        }


        const option = new Option(name, color);

        handleUpdate(option);
    }

    const handleDelete = () => {
        handleRemove();
    }

    if(showConfirmDelete)
    {

        return (
            <Dialog onClose={() => handleClose()} open={open} sx={{maxWidth: 'inherit', minWidth: '400px'}}>
                <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold', fontSize: '15px'}}>Remove option '{initialState.option.name}' ?</DialogTitle>
                <Box sx={{p:2}}>
                    <Typography>Are you sure you want to remove this option? It will be removed on from all days as well. This action is not reversible. All traces of this option will disappear.</Typography>
                </Box>
                <Box sx={{display: 'flex', flexGrow: 1}}>

                    <Button variant={'contained'} fullWidth={true} sx={{borderRadius: 0, height: '50px'}} onClick={() => setShowConfirmDelete(false)}>
                        No, don't remove
                    </Button>
                    <Button variant={'contained'} color={'error'} fullWidth={true} sx={{borderRadius: 0, height: '50px'}} onClick={() => handleDelete()}>
                        Yes, remove
                    </Button>
                </Box>

            </Dialog>
        )

    }

    return (
        <Dialog onClose={() => handleClose()} open={open} sx={{maxWidth: 'inherit', minWidth: '400px'}}>
                <DialogTitle sx={{textAlign: 'center', fontWeight: 'bold', fontSize: '15px'}}>Modify option</DialogTitle>
                <Box sx={{position: 'absolute', right: '8px', top: '8px'}} onClick={() => handleClose()} >
                    <CloseIcon />
                </Box>
            <Box sx={{
                maxWidth: 'inherit',
                minWidth: '335px',
                width: '70vw',
            }}>
                <Box sx={{ width: '80%', margin: 'auto', py: 2, display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 4}}>
                    <TextField variant={"standard"} fullWidth={true} value={name} label={'Name'} onChange={(e) => setName(e.target.value)} />
                    <Wheel color={color} onChange={(colorRes) => setColor(colorRes.hex)} />
                    <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 0.5 }}>
                        <Box sx={{ width: '75px', height: '25px', backgroundColor: color, border: '2px solid #c3c3c3', borderRadius: 3 }} />
                        <Typography>{ ntc.name(color)[1] }</Typography>
                    </Box>
                </Box>
            </Box>

            <Box sx={{display: 'flex', flexGrow: 1}}>
                <Button variant={'contained'} color={'error'} fullWidth={true} sx={{borderRadius: 0, height: '50px'}} onClick={() => setShowConfirmDelete(true)}>
                    Delete
                </Button>
                <Button variant={'contained'} fullWidth={true} sx={{borderRadius: 0, height: '50px'}} onClick={() => handleModify()}>
                    Update
                </Button>
            </Box>
        </Dialog>
    )

}